export default __webpack_public_path__ + "static/media/letter-spacing.cb036cd4.svg";